import React from 'react';

class Egg {
    getConfigData = async () => {
        return await fetch(`${process.env.REACT_APP_API_URL}/config`).then(res => res.text());
    }

    buyEgg = async (address, signature, dataThatWasSigned) => {
        return await fetch(`${process.env.REACT_APP_API_URL}/egg`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                address: address.toLowerCase(),
                signature: signature,
                dataThatWasSigned: dataThatWasSigned,
            })
        }).then(res => res.text())
    }
}

export default new Egg();
